import React from 'react';
import PropTypes from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import { ReactComponent as IconWarning } from '../../../../assets/images/ic-warning.svg';
import './ModalAdvertenciaDescarga.scss';

/**
 * Modal para mostrar advertencia antes de descargar
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal (cancelar)
 * @param {function} props.onConfirm - Función para confirmar y proceder con la descarga
 * @returns {React.ReactElement} - Componente ModalAdvertenciaDescarga
 */
const ModalAdvertenciaDescarga = ({ show, onClose, onConfirm }) => (
  <AUIModal
    autoHeight
    size="xs"
    show={show}
    title="Advertencia"
    className="modal-advertencia-descarga"
    actionButtons={[
      {
        id: 'confirm',
        mode: 'primary',
        label: 'Aceptar',
        onClick: onConfirm,
        disabled: false,
      },
       {
        id: 'cancel',
        mode: 'tertiary',
        label: 'Cancelar',
        onClick: onClose,
        disabled: false,
      },
    ]}
    onClose={onClose}
  >
    <div className="modal-content">
      <IconWarning />
      <p>
        <b>Las notas</b> de modificación jurídica y de coordinación con otros instrumentos públicos <b>emitidas después de la 
        expedición de la copia no estarán disponibles en el documento que va a descargar.</b> Solo figuran en el 
        justificante de expedición de la copia.
      </p>
    </div>
  </AUIModal>
);

ModalAdvertenciaDescarga.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ModalAdvertenciaDescarga;

